import { useAuthStore } from '@/stores/authStore';
import { useStationStore } from '@/stores/stationStore';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '@/services/authService';
export function useAuth() {
  const { user, tokens, isAuthenticated, setAuth, logout: clearAuth } = useAuthStore();
  const { clearStation } = useStationStore();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const login = useCallback(async (phone: string, password: string) => {
    setLoading(true); setError(null);
    try { const r = await authService.login({ phone, password }); setAuth(r.user, r.tokens); navigate('/dashboard'); return r; }
    catch (e: any) { setError(e.response?.data?.error?.message ?? 'Login failed'); throw e; }
    finally { setLoading(false); }
  }, [setAuth, navigate]);
  const register = useCallback(async (data: Record<string, unknown>) => {
    setLoading(true); setError(null);
    try { return await authService.register(data); }
    catch (e: any) { setError(e.response?.data?.error?.message ?? 'Registration failed'); throw e; }
    finally { setLoading(false); }
  }, []);
  const sendOTP = useCallback(async (phone: string, purpose: 'login' | 'register' | 'reset_password') => {
    setLoading(true); setError(null);
    try { return await authService.sendOTP(phone, purpose); }
    catch (e: any) { setError(e.response?.data?.error?.message ?? 'Failed to send OTP'); throw e; }
    finally { setLoading(false); }
  }, []);
  const verifyOTP = useCallback(async (phone: string, otp: string, purpose: 'login' | 'register' | 'reset_password') => {
    setLoading(true); setError(null);
    try {
      const r = await authService.verifyOTP({ phone, otp, purpose });
      if ('user' in r && 'tokens' in r) { setAuth(r.user, r.tokens); navigate('/dashboard'); }
      return r;
    }
    catch (e: any) { setError(e.response?.data?.error?.message ?? 'Verification failed'); throw e; }
    finally { setLoading(false); }
  }, [setAuth, navigate]);
  const logout = useCallback(async () => {
    try { if (tokens?.refreshToken) await authService.logout(tokens.refreshToken); } catch {}
    clearAuth(); clearStation(); navigate('/login');
  }, [clearAuth, clearStation, navigate, tokens]);
  return { user, tokens, isAuthenticated, loading, error, login, register, sendOTP, verifyOTP, logout, clearError: () => setError(null) };
}
